import styled from 'styled-components';

const RPopupStyled = styled.div`
  position: relative;
  top: ${({ popupPosition }) =>
    popupPosition.y ? `${popupPosition.y}px` : '50%'};
  left: ${({ popupPosition }) =>
    popupPosition.x ? `${popupPosition.x}px` : '50%'};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.gray25};
  z-index: 100;
  height: min-content;
  border-radius: 16px;
  pointer-events: auto;

  ${({ popupPosition }) =>
    !(popupPosition.x && popupPosition.y) &&
    'transform: translate(-50%, -50%);'};

  ${({ css }) => css}
`;

export { RPopupStyled };
